import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import Bugsnag from '@bugsnag/js';
import PropTypes from 'prop-types';

import { useToastContext } from 'components/common/ToastBannerProvider/ToastBannerProvider';
import { useAuthContext } from 'contexts/AuthContext/AuthContextProvider';

const SessionWrapper = ({ children }) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const isLoggedInSSO = urlParams.get('logged_in');
  const isLoggedOut = urlParams.get('logged_out');
  const { handleLogin } = useAuthContext();

  // Strip logged_out from the URL without a full reload (preserves one-time Rails flash on the login page).
  useEffect(() => {
    if (isLoggedOut) {
      const url = new URL(window.location.href);
      url.searchParams.delete('logged_out');
      window.history.replaceState(null, '', url.pathname + url.search);
    }
  }, [isLoggedOut]);

  useEffect(() => {
    if (isLoggedInSSO) {
      handleLogin();
    }
  }, [isLoggedInSSO]);

  // Listens for logged in changes and refreshes the page
  useEffect(() => {
    const storageChange = (event) => {
      if (event.key === 'logged_in') {
        if (event.newValue === 'false') {
          window.location.assign('/sessions/new');
        } else {
          window.location.reload(true);
        }
        Bugsnag.leaveBreadcrumb('storageChange', {
          key: event.key,
          newValue: event.newValue,
        });
      }
    };
    window.addEventListener('storage', storageChange, false);

    return () => window.removeEventListener('storage', storageChange);
  }, []);

  const { addToast } = useToastContext();
  useEffect(() => {
    if (window.flashData?.length) {
      const [type, message] = window.flashData[0];
      const variants = {
        error: 'alert',
        success: 'success',
      };
      const variant = variants[type];
      if (variant && message) {
        addToast({ variant, message });
      }
    }
  }, []);

  return children;
};

SessionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SessionWrapper;
